<template>
  <component :is="tag" class="page-title">
    <slot />
  </component>
</template>

<script>
export default {
  name: "PageTitle",
  props: {
    tag: {
      type: String,
      default: "div"
    }
  }
};
</script>

<style lang="scss">
.page-title {
  font-family: "Montserrat";
  font-weight: 900;
  font-size: 52px;
  line-height: 1.15;
  letter-spacing: 0.02em;
  text-align: center;
  color: #fbc33e;
  margin-bottom: 1.5em;

  @include breakpoint("md-and-down") {
    font-size: 42px;
  }

  @include breakpoint("sm-and-down") {
    font-size: 36px;
  }

  @include breakpoint("xs-only") {
    font-size: 28px;
  }
}
</style>
